// extracted by mini-css-extract-plugin
export var errorsContainer = "_ul-1";
export var link = "_ul-0";